<template>
  <v-app>
    <!-- Header -->
    <v-app-bar
      app
      elevation="0"
      class="px-3"
      color="transparent"
      :class="{ 'blur-bg': scrolled }"
    >
      <v-app-bar-title class="font-weight-bold">
        <span class="text-primary">Promxa</span> System
      </v-app-bar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-for="item in menuItems"
        :key="item.path"
        variant="text"
        :to="item.path"
        class="text-secondary font-weight-medium"
      >
        {{ item.name }}
      </v-btn>
    </v-app-bar>

    <!-- Main Content -->
    <v-main>
      <v-container class="py-16">
        <v-row>
          <v-col cols="12" md="8" offset-md="2">
            <div class="text-center mb-12">
              <span
                class="text-primary text-uppercase font-weight-medium"
                data-aos="fade-up"
                >Privacy</span
              >
              <h1
                class="text-h3 font-weight-bold mt-2"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                Privacy Policy
              </h1>
            </div>

            <v-card
              class="pa-8"
              elevation="4"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div class="policy-section">
                <p class="mb-6 text-medium-emphasis">
                  At Promxa, accessible from promxa.com, one of our main
                  priorities is the privacy of our visitors. This Privacy Policy
                  document contains types of information that is collected and
                  recorded by Promxa and how we use it. If you have additional
                  questions or require more information about our Privacy
                  Policy, do not hesitate to contact us.
                </p>
                <p class="mb-6 text-medium-emphasis">
                  This Privacy Policy applies only to our online activities and
                  is valid for visitors to our website with regards to the
                  information that they shared and/or collect in Promxa. This
                  policy is not applicable to any information collected offline
                  or via channels other than this website.
                </p>

                <h2 class="text-h5 font-weight-bold mb-4 text-primary">
                  Consent
                </h2>
                <p class="mb-6 text-medium-emphasis">
                  By using our website, you hereby consent to our Privacy Policy
                  and agree to its terms.
                </p>

                <h2 class="text-h5 font-weight-bold mb-4 text-primary">
                  Information We Collect
                </h2>
                <p class="mb-6 text-medium-emphasis">
                  The personal information that you are asked to provide, and
                  the reasons why you are asked to provide it, will be made
                  clear to you at the point we ask you to provide your personal
                  information.
                </p>
                <p class="mb-6 text-medium-emphasis">
                  If you contact us directly, we may receive additional
                  information about you such as your name, email address, phone
                  number, the contents of the message and/or attachments you may
                  send us, and any other information you may choose to provide.
                </p>
                <p class="mb-6 text-medium-emphasis">
                  When you register for an Account, we may ask for your contact
                  information, including items such as name, company name,
                  address, email address, and telephone number.
                </p>

                <h2 class="text-h5 font-weight-bold mb-4 text-primary">
                  How We Use Your Information
                </h2>
                <p class="mb-6 text-medium-emphasis">
                  We use the information we collect in various ways, including:
                </p>
                <ul class="mb-6 text-medium-emphasis">
                  <li>Provide, operate, and maintain our website</li>
                  <li>Improve, personalize, and expand our website</li>
                  <li>Understand and analyze how you use our website</li>
                  <li>
                    Develop new products, services, features, and functionality
                  </li>
                  <li>
                    Communicate with you, either directly or through one of our
                    partners, including for customer service, to provide you
                    with updates and other information relating to the website,
                    and for marketing and promotional purposes
                  </li>
                  <li>Send you emails</li>
                  <li>Find and prevent fraud</li>
                </ul>

                <h2 class="text-h5 font-weight-bold mb-4 text-primary">
                  Log Files
                </h2>
                <p class="mb-6 text-medium-emphasis">
                  Promxa follows a standard procedure of using log files. These
                  files log visitors when they visit websites. All hosting
                  companies do this as part of hosting services' analytics. The
                  information collected by log files include internet protocol
                  (IP) addresses, browser type, Internet Service Provider (ISP),
                  date and time stamp, referring/exit pages, and possibly the
                  number of clicks. These are not linked to any information that
                  is personally identifiable. The purpose of the information is
                  for analyzing trends, administering the site, tracking users’
                  movement on the website, and gathering demographic
                  information.
                </p>

                <h2 class="text-h5 font-weight-bold mb-4 text-primary">
                  Cookies and Web Beacons
                </h2>
                <p class="mb-6 text-medium-emphasis">
                  Like any other website, Promxa uses “cookies”. These cookies
                  are used to store information including visitors’ preferences,
                  and the pages on the website that the visitor accessed or
                  visited. The information is used to optimize the users’
                  experience by customizing our web page content based on
                  visitors’ browser type and/or other information.
                </p>

                <h2 class="text-h5 font-weight-bold mb-4 text-primary">
                  Changes to This Privacy Policy
                </h2>
                <p class="mb-6 text-medium-emphasis">
                  We may update our Privacy Policy from time to time. Thus, we
                  advise you to review this page periodically for any changes.
                  We will notify you of any changes by posting the new Privacy
                  Policy on this page. These changes are effective immediately,
                  after they are posted on this page.
                </p>

                <h2 class="text-h5 font-weight-bold mb-4 text-primary">
                  Contact Us
                </h2>
                <p class="mb-6 text-medium-emphasis">
                  If you have any questions or suggestions about our Privacy
                  Policy, do not hesitate to contact us at
                  <strong>support@promxa.com</strong>.
                </p>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <!-- Footer -->
    <v-footer app class="d-flex flex-column bg-primary">
      <div class="px-4 py-2 text-center w-100 text-white">
        {{ new Date().getFullYear() }} — <strong>Promxa System</strong>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "PolicyView",
  data() {
    return {
      scrolled: false,
      menuItems: [
        { name: "Home", path: "/" },
        { name: "Terms", path: "/terms" },
        { name: "Policy", path: "/privacy" },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 50;
    },
  },
};
</script>

<style scoped>
.policy-section h2 {
  position: relative;
  padding-left: 20px;
}

.policy-section h2::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 24px;
  background-color: #2e989e;
  border-radius: 2px;
}

.blur-bg {
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.8) !important;
}
</style>
